module.exports = __webpack_public_path__ + "static/media/dog.a70ea4a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinContainer/dog.svg
// module id = 351
// module chunks = 0